import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/dmca-protection.png")